import { Baseline } from '@/types';
import {
  Card,
  Content,
  Inline,
  InlineItem,
  Secondary,
  Pill,
  Text,
  Stack,
} from '@kinesis/bungle';
import { GHGProtocolIcon } from '@/components/ghg-protocol-icon';
import { formatDistanceStrings } from '@/date';
import { renderSubSector, renderAllDataType } from '@/data/labels';

const Item = (props: ItemProps) => {
  const { baseline, now } = props;

  return (
    <Content borderRadiusSize='small'>
      <Card>
        <Content padding='medium' paddingMode='equal'>
          <Inline space='medium'>
            <InlineItem>
              <GHGProtocolIcon />
            </InlineItem>
            <InlineItem ellipsify>
              <Stack space='small'>
                <Inline space='small'>
                  <InlineItem>
                    <Pill>{renderSubSector(baseline.subSector)}</Pill>
                  </InlineItem>
                  <InlineItem>
                    <Text>/</Text>
                  </InlineItem>
                  <InlineItem>
                    <Pill>{renderAllDataType(baseline.dataType)}</Pill>
                  </InlineItem>
                  <InlineItem>
                    <Text>/</Text>
                  </InlineItem>
                  <InlineItem>
                    <Text>{baseline.dataTypeSource}</Text>
                  </InlineItem>
                </Inline>

                <Secondary>{`Last updated ${formatDistanceStrings(now, baseline.updatedAt)}`}</Secondary>
              </Stack>
            </InlineItem>
          </Inline>
        </Content>
      </Card>
    </Content>
  );
};

export type ItemProps = {
  baseline: Baseline;
  now: string;
};

export { Item };
